import {
  DateFragment,
  DateTime,
  Time,
  TimeOfDay,
  TimezoneRegion,
  Utc,
} from "@tento-chrono";
import { type SheetRow } from "@tento-lona";
import { SheetViewModel } from "@tento-lona";
import { DataAliasPlugin } from "../../data.ts";
import type { CalendarSubcolumnSpan } from "@tento-lona/sheets-ui/sheet/calendar-subcolumn.ts";
import { SpanSleep } from "./span-sleep.ts";
import type { SheetBinder } from "../../../../sheet/sheet-index-renderer.ts";

export namespace DebugSleepSpan {
  function makeFakeSleepData(
    date: DateFragment["date"],
    tz: TimezoneRegion,
  ): { id: string; range: DateTime.Range<Utc> } {
    const noise = () => Math.floor((Math.random() - 0.5) * 60);

    const startTime = new TimeOfDay(
      Time.MS_PER_HR * 22 + noise() * Time.MS_PER_MIN,
    );
    const endTime = new TimeOfDay(
      Time.MS_PER_HR * 8 + noise() * Time.MS_PER_MIN,
    );

    const start = date.withTime(startTime);
    const end = date.add({ days: 1 }).withTime(endTime);

    return {
      id: date.toString(),
      range: new DateTime.Range(
        tz.toWallClock(start).toUtc(),
        tz.toWallClock(end).toUtc(),
      ),
    };
  }
  export const makeSpansFactory =
    (
      _plugin: DataAliasPlugin,
      _sheet: SheetViewModel.Surface<SheetBinder>,
      _row: SheetRow.Joined.Handle,
    ) =>
    async (
      windowed: DateFragment.Windowed,
      tz: TimezoneRegion,
    ): Promise<CalendarSubcolumnSpan[]> => {
      const pmSleep = makeFakeSleepData(windowed.fragment.date, tz);
      const amSleep = makeFakeSleepData(
        windowed.fragment.date.sub({ days: 1 }),
        tz,
      );

      return [
        SpanSleep.makeSpan(pmSleep.id, pmSleep.range),
        {
          ...SpanSleep.makeSpan(`${amSleep.id}-am`, amSleep.range),
          pointerEvents: "none",
        },
      ];
    };
}
